module.exports = __webpack_public_path__ + "media/app/images/credit_card@2x-241b622a5ac43c22104e37773faf09ed.png";